<div class="w-100 border br-24 pb-4 px-4 pt-4 bg-white box-shadow mt-5" *ngIf="isLogged">

  <!-- <h5 class="font-trueno-bold mb-3 text-black">{{ 'HEADER.MY_ACCOUNT' | translate }}</h5> -->
  <div class="flex-grow-1 d-flex align-items-center justify-content-center mb-5" *ngIf="isLoading">
    <div class="spinner-border text-primary"></div>
  </div>

  <h5 class="font-trueno-bold my-3 text-black">{{ "PROFILE.TITLE" | translate }}</h5>
  <div class="flex-grow-1 d-flex align-items-center justify-content-center mb-5" *ngIf="isLoading">
    <div class="spinner-border text-primary"></div>
  </div>
  <div class="pt-3" *ngIf="currentUser">


    <div class="mt-1 position-relative">

      <mat-form-field *ngIf="!isEdit" class="w-100">
        <mat-label>{{ "PROFILE.FIRSTNAME" | translate }}</mat-label>
        <input matInput type="text" (keyup)="checkLatin('firstname',$event)" placeholder="{{ currentUser?.firstname }}" [formControl]='form.controls.firstname'>
      </mat-form-field>
      <div *ngIf="errors.firstname" class="text-danger" style="margin-top: -15px;margin-bottom: 5px;">
        {{errors.firstname}}
      </div>

      <mat-form-field *ngIf="!isEdit" class="mt-2 w-100">
        <mat-label>{{ "PROFILE.LASTNAME" | translate }}</mat-label>
        <input matInput (keyup)="checkLatin('lastname',$event)" type="text" placeholder="{{ currentUser?.lastname }}" [formControl]='form.controls.lastname'>
      </mat-form-field>
      <div *ngIf="errors.lastname" class="text-danger" style="margin-top: -15px;margin-bottom: 5px;">
        {{errors.lastname}}
      </div>

      <mat-form-field class="col-12 pb-0 mt-2 mb-4">
        <mat-label class="text-black subtitle_1">{{ "COMMON.USER.EMAIL" | translate }}</mat-label>
        <input class="text_3" disabled matInput type="text" value="{{currentUser.email}}">
      </mat-form-field>


      <div class="pb-3">
        <span class="label mediumGray font-12"
          [ngClass]="{'text-danger': !isBirthdayCorrect || (isFormSubmit && form.controls.birthdate.invalid)}">{{ "PROFILE.BIRTHDATE" | translate }}</span>
        <div class="text-danger font-12"
          *ngIf="!isBirthdayCorrect || (isFormSubmit && form.controls.birthdate.invalid)">{{ 'COMMON.BIRTHDATE_FORMAT.INVALIDE' | translate }}</div>
        <app-birthdate-divided #birthdateDividedComponent [birthdate]="currentUser.birthdate" [type]="'birthdate'"
          (newBirthdate)="setInfos($event, 'birthdate')"></app-birthdate-divided>
      </div>
      <div class="position-relative">
        <span class="label mediumGray font-12 customLabel">{{'COMMON.USER.PLACEOFBIRTH' | translate}} *</span>
        <app-city-input #cityInputComponent (hasBeenClick)="hasBeenClick($event)" (onManualChange)="changeManualInput()"
                        (onChange)="setInfos($event, 'city')" [cityControl]="form.controls.birthplace"
                        [floatLabel]="'always'" [labelContent]=""
                        [user]="currentUser" [wantedField]="'birthplace'"
          class="mediumGray"></app-city-input>
        <div *ngIf="form.controls.birthplace.valid"
          class="position-absolute text-success d-flex align-items-center font-12">
          <span class="material-icons-outlined font-12 me-1">done</span>
          {{ 'COMMON.OK_CHECKED' | translate }}
        </div>
      </div>
      <div *ngIf="errors.birthplace" class="text-danger" style="margin-bottom: 5px;">
        {{errors.birthplace}}
      </div>

    </div>
  </div>
  <h5 class="font-trueno-bold my-3 text-black">{{ "COMMON.USER.STUDY_PROJECT" | translate }}</h5>
  <div class="flex-grow-1 d-flex align-items-center justify-content-center mb-5" *ngIf="isLoading">
    <div class="spinner-border text-primary"></div>
  </div>
  <div class="pt-3 mb-3" *ngIf="currentUser">
    <mat-form-field *ngIf="!isEdit" class="w-100">
      <mat-label>{{ 'COMMON.USER.STUDY_CITY' | translate }}</mat-label>
      <mat-select [formControl]="form.controls.studyPlace" required (valueChange)="checkCity($event)" (openedChange)="metropoleSelectIsOpen = !metropoleSelectIsOpen">
        <mat-option *ngFor="let city of startingCities; trackBy:trackBy" [disabled]="!city.minPrice || city.hideInHC == 1" class="CustomLineHeight" [value]="city.id">
          <span class="title_3">{{ city.name }}</span>
          <ng-container *ngIf="city.minPrice && city.hideInHC !== 1">
            <span class="minitext_1 mediumGray ms-1" *ngIf="metropoleSelectIsOpen" [innerHTML]="'COMMON.USER.STUDYPLACERENT' | translate:{minPrice: city.minPrice, maxPrice: city.maxPrice}"> - </span>
          </ng-container>
          <ng-container *ngIf="!city.minPrice || city.hideInHC === 1">
            <span *ngIf="metropoleSelectIsOpen" class="minitext_1 mediumGray disabled ms-1">{{"COMMON.USER.STUDYPLACEINDISPO" | translate}}</span>
          </ng-container>
        </mat-option>
      </mat-select>
      <mat-error>{{ "COMMON.IS_REQUIRED" | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="!isEdit && districtCities && districtCities.length > 0" class="w-100">
      <mat-label>{{ 'COMMON.USER.STUDY_DISTRICT' | translate }}</mat-label>
      <mat-select [formControl]="form.controls.sector" required (openedChange)="districtSelectIsOpen = !districtSelectIsOpen">
        <mat-option *ngFor="let city of districtCities; trackBy:trackBy" [disabled]="!city.minPrice" class="CustomLineHeight" [value]="city.id">
          <span class="title_3">{{ city.name }}</span>
          <ng-container *ngIf="city.minPrice">
            <span class="minitext_1 mediumGray ms-1" *ngIf="districtSelectIsOpen" [innerHTML]="'COMMON.USER.STUDYPLACERENT' | translate:{minPrice: city.minPrice, maxPrice: city.maxPrice}"> - </span>
          </ng-container>
          <ng-container *ngIf="!city.minPrice">
            <span *ngIf="districtSelectIsOpen" class="minitext_1 mediumGray disabled ms-1">{{"COMMON.USER.STUDYPLACEINDISPO" | translate}}</span>
          </ng-container>
        </mat-option>
      </mat-select>
      <mat-error>{{ "COMMON.IS_REQUIRED" | translate }}</mat-error>
    </mat-form-field>


    <div class="position-relative mb-2">
      <mat-form-field class="w-100" (focusin)="changeDisplayUnit()" (focusout)="changeDisplayUnit()">
        <mat-label>{{ 'PROFILE.STAY_DURATION' | translate }}</mat-label>
        <input matInput type="number" min="1" max="200" class="mt-2" [formControl]="form.controls.stayDuration">
        <div class="input_unit" *ngIf="displayUnit || (!displayUnit && form.controls.stayDuration.value)">
          <span class="invisible">{{ form.controls.stayDuration.value }}</span>
          <span class="ms-1">
            {{ (form.controls.stayDuration.value <= 1 ? 'COMMON.MONTH' : 'COMMON.MONTHS')| translate }}
          </span>
        </div>
        <mat-error>{{ "COMMON.IS_REQUIRED" | translate }}</mat-error>
      </mat-form-field>
      <div class="position-absolute text-success d-flex align-items-center font-12 address-check mt-4 mt-lg-3 "
        *ngIf="form.controls.stayDuration.valid">
        <span class="material-icons-outlined font-12 me-1">done</span>
        {{ 'COMMON.OK_CHECKED' | translate }}
      </div>
    </div>

    <span class="label mediumGray mb-3 font-14"
      [ngClass]="{'text-danger': !isArrivalDateCorrect || (isFormSubmit && form.controls.arrivalDate.invalid)}">
        {{ 'COMMON.USER.ESTIMATE_ARRIVAL_DATE' | translate }}
      </span>
    <div class="text-danger font-12"
      *ngIf="!isArrivalDateCorrect || (isFormSubmit && form.controls.arrivalDate.invalid)">{{ 'PROCESSES.VISA.APPOINTMENT_PAGE_2.DATE_ERROR' | translate }}</div>
    <app-birthdate-divided #ArrivalComponent [birthdate]="currentUser.arrivalDate" [type]="'future'"
      (newBirthdate)="setInfos($event, 'arrivalDate')"
      [ngClass]="{'is-invalid': !isArrivalDateCorrect || (isFormSubmit && form.controls.arrivalDate.invalid)}"></app-birthdate-divided>

  </div>

</div>
<div class="position-sticky mt-3 bg-white py-3 pb-lg-0 bottom_sticky" *ngIf="isLogged">
  <button class="btn btn-primary w-100 fw-bold" (click)="validateForm()" checkFormError [disabled]="updateStatus">
    <span class="material-icons-outlined me-1 va-sub" *ngIf="!updateStatus">download_done</span>
    <span *ngIf="updateStatus" class="spinner-border spinner-border-sm me-1 v-middle"></span>
    <span *ngIf="!updateStatus">{{ 'COMMON.CONFIRM_INFOS' | translate }}</span>
    <span *ngIf="updateStatus">{{ (updateStatus == 'updating' ? 'COMMON.UPDATE_INFORMATIONS' : 'COMMON.GENERATING_PDF') | translate }}</span>
  </button>
</div>

<app-form-login *ngIf="!isLogged" [smallTitle]="'COMMON.REGISTER_TO_CONTINUE'"></app-form-login>


<!-- CANT GIVE CERTIFICATE MODAL -->
<ng-template #CantDeliverDiv let-modal>
  <div class="modal-header d-inline bg-white">
    <h5 class="modal-title d-flex align-items-baseline align-items-sm-center" id="modal-basic-title">
      {{ 'PROCESSES.HOUSING_CERTIFICATE.CANT_DELIVER.TITLE' | translate }}
      <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
        <span class="material-icons-outlined text-black">close</span>
      </button>
    </h5>
  </div>
  <div class="modal-body bg-white d-flex flex-column">
    <h5>{{ 'PROCESSES.HOUSING_CERTIFICATE.CANT_DELIVER.SUBTITLE' | translate }}</h5>
    <p>{{ 'PROCESSES.HOUSING_CERTIFICATE.CANT_DELIVER.TEXT_1' | translate }}</p>
    <button class="btn btn-primary py-3 mt-3"
      (click)="goto()">{{ 'HEADER.BTN_HOVER_BACK_DASHBOARD' | translate }}</button>
  </div>
</ng-template>
